<template>
  <b-input-group
    id="searchBar"
    v-click-outside="removeFieldFocus"
    class="justify-content-end"
    size="lg"
    placeholder="Search"
  >
    <b-input-group-text slot="append">
      <img
        class="search-button"
        src="@/assets/search.png"
        alt
        @click="search"
      />
    </b-input-group-text>
    <b-form-input
      v-model="searchTerm"
      placeholder="Search"
      @focus="fieldFocus = true"
      @keyup.enter="search"
    ></b-form-input>
    <SearchSuggestions
      :field-focus="fieldFocus"
      :search-term="searchTerm"
      @removeFieldFocus="removeFieldFocus"
    />
  </b-input-group>
</template>

<script>
import Store from "@/store";
import SearchSuggestions from "@/components/SearchSuggestions";

export default {
  components: {
    SearchSuggestions
  },
  directives: {
    "click-outside": {
      bind: function(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
          // here I check that click was outside the el and his childrens
          if (!(el == event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
      },
      unbind: function(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
      }
    }
  },
  data() {
    return {
      store: Store.state,
      searchTerm: "",
      universesList: null,
      fieldFocus: false
    };
  },
  methods: {
    search() {
      Store.addFilter(null, "globalSearch", this.searchTerm);
    },
    removeFieldFocus() {
      this.fieldFocus = false;
    }
  }
};
</script>

<style lang="scss" scoped>
#searchBar input {
  border-radius: 50px;
  border: 1px solid rgb(235, 111, 51);
  height: 40px;
  max-width: 280px;
  font-size: 14px;
}
.input-group {
  & > .input-group-append {
    margin-left: -40px;
    & > .input-group-text {
      z-index: 10;
      border-radius: 50px;
      height: 40px;
      border: none;
      padding: 0;
      cursor: pointer;
    }
  }
}
</style>
